import apolloProvider from '@/vue-apollo';
const apolloClient = apolloProvider.clients.private;

import { removeKey } from '@/helpers';

import UpdateMemberGql from '@/extensions/restricted-area/store/graphql/mutations/UpdateMember.gql';
import ValidateMemberEmailGql from '@/extensions/restricted-area/store/graphql/queries/ValidateMemberEmail.gql';

export default {
    update: member => {
        if (member === undefined) throw new Error('required argument missing');
        member = removeKey(member, '__typename');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UpdateMemberGql,
                    variables: { member }
                })
                .then(({ data }) => {
                    apolloClient.clearStore();
                    resolve(data.EX_RSTRCT_UpdateMember);
                })
                .catch(err => reject(err));
        });
    },
    validateEmail: email => {
        if (email === undefined) throw new Error('required argument missing');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: ValidateMemberEmailGql,
                    variables: { email }
                })
                .then(({ data }) => {
                    apolloClient.clearStore();
                    resolve(data.EX_RSTRCT_ValidateMemberEmail);
                })
                .catch(err => reject(err));
        });
    }
};
